import cx from 'classnames';
import { DateTime } from 'luxon';
import { BaseImpact } from '../../data/api';
import Link from 'next/link';
import { useMemo } from 'react';

function statusToDisplay(status: BaseImpact['completed']): {
    str: string;
    color: string;
} {
    switch (status) {
        case 'completed':
            return { str: 'Completed', color: 'bg-green-30' };
        case 'in_progress':
            return { str: 'In Progress', color: 'bg-yellow-50' };
        case 'not_started':
            return { str: 'Not Started', color: 'bg-red-30' };
        default:
            throw new Error('invalid status');
    }
}

function impactDateTimeSortFn(a: BaseImpact, b: BaseImpact) {
    const aDateTime = DateTime.fromISO(a.start_date);
    const bDateTime = DateTime.fromISO(b.start_date);
    return aDateTime > bDateTime ? 1 : aDateTime < bDateTime ? -1 : 0;
}

interface ImpactListProps {
    impacts: BaseImpact[];
    locationName: string;
}

function ImpactList({ locationName, impacts }: ImpactListProps) {
    const sortedImpacts = useMemo(
        () => [...impacts].sort(impactDateTimeSortFn),
        [impacts]
    );
    if (impacts.length === 0) {
        return null;
    }

    return (
        <div className="mx-6 my-12 max-w-[1200px] mx-auto">
            <h1 className="my-6 text-4xl font-semibold underline decoration-4 decoration-[#00E396]">
                {locationName} Impacts
            </h1>
            <div className="p-2 bg-gray-10 rounded">
                <table className="w-full  table-auto border-separate border-spacing-y-2">
                    <thead>
                        <tr className="text-right">
                            <th className="text-left p-3">Impact</th>
                            <th className="p-3">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedImpacts.map(impact => (
                            <tr
                                key={impact.slug}
                                className="relative text-sm text-right bg-gray-00 opacity-1 hover:opacity-80 hover:cursor-pointer"
                            >
                                <td className="text-left font-semibold p-3">
                                    <Link href={`/impact/${impact.slug}`}>
                                        <a className=" before:block before:absolute before:left-0 before:top-0 before:w-full before:h-full hover:text-blue-50">
                                            {impact.name}
                                        </a>
                                    </Link>
                                </td>
                                <td className="p-3">
                                    <span
                                        className={cx(
                                            'py-1 px-2 whitespace-nowrap rounded',
                                            statusToDisplay(impact.completed)
                                                .color
                                        )}
                                    >
                                        {statusToDisplay(impact.completed).str}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ImpactList;
